'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useMatchMedia = require('./use-match-media.js');

/**
 * A React hook for detecting `prefers-reduced-motion`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 *
 * @example const prefersReducedMotion = usePrefersReducedMotion();
 * @returns boolean
 */ const usePrefersReducedMotion = ()=>{
    return useMatchMedia.useMatchMedia('(prefers-reduced-motion: reduce)');
};

exports.usePrefersReducedMotion = usePrefersReducedMotion;
//# sourceMappingURL=use-prefers-reduced-motion.js.map
